import type { SectionName } from '@coursera/event-pulse-types';

/** Section name for event-pulse tracking: AI summary block on search results. */
export const SEARCH_AI_SUMMARY_SECTION: SectionName = 'search_ai_summary';

/** Section name for event-pulse tracking: NL (natural language) suggestions on search results. */
export const SEARCH_NL_SUGGESTIONS_SECTION: SectionName = 'search_nl_suggestions';

/** Section name for event-pulse tracking: no-results recommendation cards on search results. */
export const SEARCH_NO_RESULTS_SECTION: SectionName = 'search_no_results';
